
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  ref
} from "vue";
import { EventCourse } from "../../../../../domain/entities/courseEvent/courseEvent";
import { useStore } from "vuex";
import { wrapLoading } from "../../../utils/wrap_loading";
import { dispatchError } from "../../../utils/error_handling";
import Card from "./Card.vue";

export default defineComponent({
  name: "UserEvents",
  components: { Card },
  setup() {
    const store = useStore();
    const isModalOpened = ref<boolean>(false);
    const selectedEvent = ref<EventCourse>(new EventCourse());

    const userEvents: ComputedRef<EventCourse[]> = computed(
      () => store.getters["userProfile_module/userEvents"]
    );

    const loadUserEvents = async (): Promise<void> => {
      try {
        await wrapLoading(async () => {
          await store.dispatch("userProfile_module/loadUserEvents");
        });
      } catch (e) {
        await dispatchError(e);
      }
    };

    onBeforeMount(async () => {
      await loadUserEvents();
    });

    return {
      selectedEvent,
      isModalOpened,
      userEvents
    };
  }
});
